/**
 * Geographic calculation utilities for map-related operations.
 *
 * Most geographic utilities have been moved to @/domain/geo.
 * This module re-exports them for backwards compatibility and adds
 * map-specific utilities like calculateRadiusFromZoom.
 */

// Re-export from geo domain for backwards compatibility
export {
  toRadians,
  toDegrees,
  calculateDistance,
  areCoordinatesEqual,
  calculateCenterPoint,
} from '@/domain/geo'

/**
 * Calculate appropriate search radius based on Google Maps zoom level.
 * Higher zoom levels use smaller search radii for more precise results.
 *
 * This is a map-specific utility that stays in the map domain.
 *
 * @param zoom - Google Maps zoom level (0-20+)
 * @returns Radius in meters
 */
export function calculateRadiusFromZoom(zoom: number): number {
  // Smaller radius at higher zoom levels for more precise searches
  if (zoom >= 15) return 1000 // 1km
  if (zoom >= 12) return 5000 // 5km
  if (zoom >= 10) return 10000 // 10km
  if (zoom >= 8) return 25000 // 25km
  return 50000 // 50km
}